import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/misc/monyx.png'


const _hoisted_1 = { class: "monyx_wrap" }
const _hoisted_2 = { class: "monyx_store_wrap" }
const _hoisted_3 = { class: "monyx_store" }
const _hoisted_4 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_5 = { style: {"color":"white","text-align":"center","line-height":"60px"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: _imports_0
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import Row from '../common/RowSection.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MonyxBanner',
  props: {
        storeUrl: { type: String, required: true },
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("a", { href: __props.storeUrl }, _hoisted_8, 8, _hoisted_6)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})